import {
  Box,
  Loader,
  RoundedBox,
  Stack,
  Typography,
} from "@braintrust/braintrust-ui-components";
import { PaymentMethodFailedTopBar } from "@js/apps/employer/components/payment-method-failed-top-bar";
import { ACCESS_RULE } from "@js/routes/constants";
import { ProtectedRoute } from "@js/routes/protected-route";

import {
  EmployerNavigation,
  EmployerOfferPreviewStatus,
  OfferDetails,
  TalentAvatarAndPersonalDetails,
} from "../../components";
import { BoilerplateOfferTermsSection } from "../../components/boilerplate-offer-terms-section";
import {
  AdditionalInfo,
  AdditionalTerms,
  CommitmentDetails,
} from "../../components/offer-preview-sections";
import {
  EquipmentShippingAddressFields,
  EquipmentShippingAddressFormInstance,
} from "../../forms";
import { useEmployerOffer } from "../../hooks";
import { OfferLayout, OfferPreviewContentLayout } from "../../layout";

import styles from "./style.module.scss";

export const EmployerPreviewOfferProtectedPage = () => {
  return (
    <ProtectedRoute
      rules={[
        ACCESS_RULE.CAN_MANAGE_JOBS,
        ACCESS_RULE.EMPLOYER_HAS_ADDRESS_SET,
      ]}
    >
      <EmployerPreviewOfferPage />
    </ProtectedRoute>
  );
};

const EmployerPreviewOfferPage = () => {
  return (
    <Stack className={styles.container}>
      <PaymentMethodFailedTopBar />
      <EmployerPreviewOfferPageContent />
    </Stack>
  );
};

const EmployerPreviewOfferPageContent = () => {
  const { loading, offer, offerId, job } = useEmployerOffer();

  if (loading || !offer || !job) {
    return (
      <OfferLayout navigationSocket={null}>
        <Loader centered />
      </OfferLayout>
    );
  }

  return (
    <OfferLayout
      navigationSocket={
        <EmployerNavigation
          pdfFile={offer.pdf_file}
          jobId={offer.bid.job.id}
          jobTitle={offer.job_title}
          offerStatus={offer.status}
          offerId={offerId}
          interlocutor={offer.bid.freelancer.user.id}
          previewPage
        />
      }
    >
      <OfferPreviewContentLayout
        leftSocket={
          <>
            <RoundedBox sx={{ px: 4, py: 3, bgcolor: "var(--medium-green)" }}>
              <TalentAvatarAndPersonalDetails
                hideNamePrefix
                bid={offer.bid}
                jobRoleName={offer.bid.job.role.name}
                boldedName={false}
              />
            </RoundedBox>
            <EmployerOfferPreviewStatus offer={offer} />
          </>
        }
        rightSocket={
          <>
            <OfferDetails showUpdatedLabel={false} offer={offer} job={job} />
            <CommitmentDetails offer={offer} />
            <AdditionalTerms offer={offer} />
            <AdditionalInfo
              offer={offer}
              bottomSocket={
                !offer.shipping_address ? null : (
                  <Box>
                    <Typography
                      component="p"
                      variant="label"
                      size="large"
                      sx={{ mt: 4, mb: 3 }}
                    >
                      Equipment shipping address
                    </Typography>
                    <EquipmentShippingAddressFormInstance
                      initialValues={{ address: offer.shipping_address }}
                    >
                      <EquipmentShippingAddressFields
                        countryAsTextField
                        disableAll
                      />
                    </EquipmentShippingAddressFormInstance>
                  </Box>
                )
              }
            />
            <BoilerplateOfferTermsSection offer={offer} />
          </>
        }
      />
    </OfferLayout>
  );
};
